import { getEnvironment } from './environment';

const environment = getEnvironment();
const isSupportingErrorLogging =
  environment === 'Development' ||
  environment === 'Test' ||
  environment === 'UAT';

export function logError(error: unknown): void {
  if (!isSupportingErrorLogging || error == null) {
    return;
  }

  const errorData = {
    error:
      error instanceof Error
        ? { name: error.name, message: error.message, stack: error.stack } // Extract properties because properties in Error object are not enumerable
        : error,
    configuration: window.location.search,
  };

  logErrorMessage(JSON.stringify(errorData));
}

function logErrorMessage(message: string): void {
  console.error(message);
  void fetch('/api/errors', {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    body: message,
  });
}
